import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'resourceLabel',
  standalone: true,
})
export class ResourceLabelPipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {}

  transform(resourceName: string | undefined | null, kind: 'TITLE' | 'DESCRIPTION'): string {
    if (!resourceName) {
      return '';
    }

    const normalized = resourceName.toUpperCase();
    const key = `RESOURCES.${normalized}.${kind}`;
    const translated = this.translate.instant(key);

    if (translated && translated !== key) {
      return translated;
    }

    const humanizedBase = normalized
      .split('.')
      .map((segment) => segment.charAt(0) + segment.slice(1).toLowerCase())
      .join(' · ');

    if (kind === 'DESCRIPTION') {
      return this.translate.instant('ADMIN.FORMS.RESOURCE_FALLBACK.DESCRIPTION', {
        resource: humanizedBase,
      });
    }

    return humanizedBase;
  }
}
